export default __webpack_public_path__ + "static/media/ReportsAlcoholInStock.3904ff54.jpg";